import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";

function NotesDialog({ isOpen, onClose, note }) {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-[620px] bg-cblack4 p-0">
        <div className="px-6 py-5">
          <DialogTitle className="text-lg font-medium text-cwhite">Notes</DialogTitle>
          <p className="mt-4 text-sm md:text-base text-cwhite2">{note || "No notes available"}</p>
        </div>
      </DialogContent>
    </Dialog>
  );
}

export default NotesDialog;
